import React, { FunctionComponent } from 'react'

import { Person } from '../../../../../App/store/features/person/IPerson'
import { IAddedActivity } from '../../../Appointment/AddActivityViewSwitch/IAddActivity'
import { ICrudActivityDetails } from '../../../types/ICrudActivityDetails'

import { ActivityPersons } from './ActivityPersons'
import {
  ActivityItemWrapper,
  ActivityListItem,
  AppointmentActivityLock,
  AppointmentActivityLockWrapper,
  AppointmentActivityRemove,
  AppointmentActivityRemoveWrapper,
} from './style'

interface IProps {
  selectedActivityArray: IAddedActivity[]
  setSelectedActivityArray: (activities: ICrudActivityDetails) => void
  personList: Person[]
  selectedPersonName?: string
}

export const ActivityList: FunctionComponent<IProps> = ({
  setSelectedActivityArray,
  selectedActivityArray,
  personList,
  selectedPersonName,
}) => {
  const updateActivityArray = (
    updatedActivity: IAddedActivity,
    updateIndex: number,
    activityUuid: string,
    isLockedUpdate?: true,
  ): void =>
    setSelectedActivityArray({
      data: [
        ...selectedActivityArray.slice(0, updateIndex),
        updatedActivity,
        ...selectedActivityArray.slice(updateIndex + 1),
      ],
      actionType: 'update',
      activityUuid,
      isLockedUpdate,
    })

  const toggleActivityLock = (
    activityIndex: number,
    activityUuid: string,
  ): void => {
    const updateIsLocked: IAddedActivity = {
      ...selectedActivityArray[activityIndex],
      isLocked: !selectedActivityArray[activityIndex].isLocked,
    }
    updateActivityArray(updateIsLocked, activityIndex, activityUuid, true)
  }
  const editActivityPerson = (
    activityIndex: number,
    personUuids: string[],
    activityUuid: string,
  ): void => {
    const updatePerson: IAddedActivity = {
      ...selectedActivityArray[activityIndex],
      personUuids,
    }
    updateActivityArray(updatePerson, activityIndex, activityUuid)
  }

  const removeSelectedActivity = (
    removeIndex: number,
    activityUuid: string | null,
  ) => {
    const newActivitiesArray = [...selectedActivityArray]
    newActivitiesArray.splice(removeIndex, 1)
    setSelectedActivityArray({
      data: newActivitiesArray,
      actionType: 'delete',
      activityUuid: activityUuid || undefined,
    })
  }

  if (selectedActivityArray.length === 0) {
    return null
  }

  return (
    <>
      {selectedActivityArray.map((chosenActivity, index) => (
        <ActivityListItem
          key={`${chosenActivity.personUuids}${chosenActivity.activity.activityUuid}`}>
          <ActivityPersons
            personList={personList}
            selectedPersonName={selectedPersonName}
            selectedActivity={selectedActivityArray[index]}
            updateSelectedPersons={editActivityPerson}
            addedIndex={index}
            activityLabel={chosenActivity.activity.name}
            customMargin="0"
          />
          <ActivityItemWrapper>
            <AppointmentActivityRemoveWrapper
              onClick={() =>
                removeSelectedActivity(
                  index,
                  chosenActivity.appointmentActivityUuid,
                )
              }>
              <AppointmentActivityRemove icon="trash" />
            </AppointmentActivityRemoveWrapper>

            <AppointmentActivityLockWrapper
              locked={chosenActivity.isLocked}
              onClick={() => {
                if (chosenActivity.appointmentActivityUuid) {
                  toggleActivityLock(
                    index,
                    chosenActivity.appointmentActivityUuid,
                  )
                }
              }}>
              <AppointmentActivityLock
                icon={
                  selectedActivityArray[index].isLocked ? 'lock' : 'lock-open'
                }
                locked={selectedActivityArray[index].isLocked}
              />
            </AppointmentActivityLockWrapper>
          </ActivityItemWrapper>
        </ActivityListItem>
      ))}
    </>
  )
}
